import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type CatalogPermissionSecondaryCategoryConfigConstructor,
  CatalogPermissionSecondaryCategoryConfig,
} from './CatalogPermissionSecondaryCategoryConfig'

export const CatalogPermissionSecondaryCategoryConfigConstructorFactory =
  Factory.Sync.makeFactory<CatalogPermissionSecondaryCategoryConfigConstructor>(
    {
      id: Factory.each(() => faker.random.number()),
      name: Factory.each(() => faker.commerce.department()),
      primaryCategoryName: Factory.each(() => faker.company.companyName()),
      grantedUserIds: [],
    }
  )

export const CatalogPermissionSecondaryCategoryConfigFactory = EntityFactory(
  CatalogPermissionSecondaryCategoryConfig,
  CatalogPermissionSecondaryCategoryConfigConstructorFactory
)
